export default "__VITE_ASSET__C_q1uQ_p__"